import { useNavigate } from "react-router";
import { useLocale } from "../context/LanguageContext";

export function UnauthorizedPage() {
  const navigate = useNavigate();
  const { t } = useLocale();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="w-full max-w-sm rounded-lg border border-border bg-card p-8 text-center shadow-sm">
        <div className="mb-4 text-4xl">🔒</div>
        <h1 className="mb-2 text-xl font-bold text-foreground">
          {t("unauthorized.title")}
        </h1>
        <p className="mb-6 text-sm text-muted-foreground">
          {t("unauthorized.message")}
        </p>
        <button
          type="button"
          onClick={() => navigate("/login", { replace: true })}
          className="rounded-lg bg-primary px-6 py-2.5 text-sm font-semibold text-primary-foreground hover:opacity-90"
        >
          {t("unauthorized.backToLogin")}
        </button>
      </div>
    </div>
  );
}
